module.exports = __webpack_public_path__ + "media/images/ringrevenue/button_left-81b359b86138c1bacbb1647731371160.png";